/* eslint-disable react/jsx-no-bind, no-return-assign, react/no-array-index-key */

import PropTypes from "prop-types";
import React from "react";
import TinySliderOverride from "./TinySliderOverride";

export default class ProductDetailsModalImageOrCarousel extends React.PureComponent {

  static propTypes = {
    "designer": PropTypes.string.isRequired,
    "images": PropTypes.object.isRequired,
    "pdName": PropTypes.string.isRequired
  };

  static defaultProps = {
    "designer": "",
    "images": {},
    "pdName": ""
  };

  constructor (props) {
    super(props);

    this.state = {"currentImageIndexShown": 0};
  }

  sliderMovesTo = (event, index) => {
    event.preventDefault();
    this.ts.slider.goTo(index);
  }

  updateCurrentIndex = () => {
    const sliderInfo = this.ts.slider.getInfo();
    const indexCurrent = sliderInfo.displayIndex - 1;

    this.setState({"currentImageIndexShown": indexCurrent});
  }

  renderSingleImageTag = (sourceUrl, imageClassName, key) => {
    const {designer, pdName} = this.props;

    return (
      <img
        alt={`${designer} ${pdName}`}
        className={imageClassName}
        key={key}
        src={sourceUrl}
      />
    );
  }

  renderImageTags = () => {
    const {images} = this.props;
    const sliderImages = (
      <div>
        {images.slice(0, 2).map((el, index) => {
          const imageClass = index === 0 ? "product-photo" : "ugc-photo";
          return this.renderSingleImageTag(el, `pd_image grid-item-link ${imageClass}`, `thumbnail_${index}`);
        })}
      </div>
    );

    return (
      <React.Fragment>
        {sliderImages}
      </React.Fragment>
    );
  }

  renderTinySlider = () => {
    const {currentImageIndexShown} = this.state;
    const {images} = this.props;

    const tinySliderSettings = {
      "controls": false,
      "items": 1,
      "lazyload": true,
      "mouseDrag": true,
      "nav": false,
      "startIndex": 0
    };

    return (
      <div>
        <div>
          <TinySliderOverride
            onIndexChanged={this.updateCurrentIndex}
            ref={ts => this.ts = ts}
            settings={tinySliderSettings}
          >
            {images.slice(0, 3).map((el, index) =>
              this.renderSingleImageTag(el, "product-photo grid-item-link", `slider_image_${index}`))}
          </TinySliderOverride>
        </div>
        <div className="slider-bullets">
          {images.slice(0, 3).map((el, index) => (
            <span
              className={`slider-bullet${currentImageIndexShown === index ? " active" : ""}`}
              key={index}
              onClick={event => this.sliderMovesTo(event, index)}
            />
          ))}
        </div>
      </div>
    );
  }

  render = () => {
    const {images} = this.props;

    if (images.length > 1) {
      return this.renderTinySlider();
    }

    return this.renderImageTags();
  }
}
